@if (Vendor) {
  <div class="container-fluid h-100 d-flex flex-column">
    <div class="row">
      <div class="col">
        <h2>History {{ Vendor ? ' - ' + Vendor.legalName : '' }}</h2>
      </div>
    </div>
    <!-- <div class="row">
    <div class="col"></div>
    <div class="col-auto">
      <div class="check-group mt-0">
        <input type="checkbox" class="form-check-input" [(ngModel)]="DisplaySystemEmailNoteModel.showSystemEmailNote" (ngModelChange)="displaySystemEmailNoteChanged($event)">
        <label class="mt-0 form-check-label">Display System & Email Notes?</label>
      </div>
    </div>
  </div> -->
    <form
      [formGroup]="historyGridControlsForm"
      class="row justify-content-end mb-2"
    >
      <div class="col d-flex flex-column align-items-end">
        <div class="row">
          <div class="col d-flex flex-column align-items-start">
            <div class="form-check">
              <label for="hideSystemLogs" class="form-check-label m-0"
                >Hide system logs?</label
              >
              <input
                id="hideSystemLogs"
                type="checkbox"
                class="form-check-input"
                formControlName="hideSystemLogs"
              />
            </div>
            <div class="form-check">
              <label for="showAccountingLogs" class="form-check-label m-0"
                >Show accounting logs?</label
              >
              <input
                id="showAccountingLogs"
                type="checkbox"
                class="form-check-input"
                formControlName="showAccountingLogs"
              />
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="row flex-grow-1 mb-3">
      <div class="col">
        @if (suppliedGridQueryData) {
          <app-notes-grid
            [suppliedQueryData]="suppliedGridQueryData"
            [ColumnIdToColumnActions]="ColumnIdToColumnActions"
            [gridName]="'ClientVendorHistory'"
            [(reloadGridData)]="reloadGrid"
            (rowClick)="action({ action: 'view', rowData: $event.data })"
          >
          </app-notes-grid>
        }
      </div>
    </div>
  </div>
}
